import React from "react";
import styled from "styled-components";
import { LinkedInIcon } from "../../../assets/icons";

export default function UsersCards({ data }) {
	return (
		<CardsContainer>
			{data?.map(({ imageSource, name, post, linkedIn }) => (
				<li key={name} className="users-cards_card">
					<img src={imageSource} alt="" />

					{name && (
						<div>
							<h4>{name}</h4>

							<p className="small">{post}</p>

							<a href={linkedIn}>
								<LinkedInIcon />
							</a>
						</div>
					)}
				</li>
			))}
		</CardsContainer>
	);
}

const CardsContainer = styled.ul`
	display: grid;
	grid-template-columns: repeat(3, minmax(300px, 1fr));
	column-gap: 30px;
	justify-content: center;
	display: flex;

	.users-cards_card {
		img {
			width: 100%;
			margin-bottom: 2rem;
		}

		h4 {
			margin-bottom: 0.4rem;
		}

		p {
			width: 90%;
			margin-bottom: 0.4rem;
		}

		a {
			margin-left: -3px;

			svg {
				width: 30px;
				height: 30px;
			}
		}
	}

	@media (max-width: 768px) {
		display: flex;
		flex-direction: column;

		.users-cards_card {
			margin-bottom: 2.4rem;

			img {
				margin-bottom: 1.5rem;
			}

			&:last-child {
				margin-bottom: 0 !important;
			}
		}
	}
`;
